export const fileExtension = (filePath: string) =>
  filePath.substring(filePath.lastIndexOf(".") + 1)
